import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-046cca31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { href: "#feature" }
const _hoisted_3 = {
  href: "#subscription",
  class: "p-mx-2"
}
const _hoisted_4 = { href: "#contact" }
const _hoisted_5 = { class: "p-d-flex p-flex-column p-ai-center p-jc-center slide-content p-text-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "p-text-left p-px-3",
  style: {"max-width":"1000px","color":"#fbc02d","line-height":"1.8"}
}, " Notre logiciel de caisse en ligne vous permet de gérer vos ventes, crédits, dépenses et stock facilement depuis n'importe quel terminal connecté à internet . ", -1))
const _hoisted_7 = { class: "p-d-inline-flex p-px-2" }
const _hoisted_8 = {
  href: "#feature",
  class: "p-button p-button-success p-mr-4"
}
const _hoisted_9 = {
  href: "#subscription",
  class: "p-button p-button-info"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "p-text-left p-px-3",
  style: {"max-width":"1000px","line-height":"1.8","color":"#fbc02d"}
}, " N'attendez pas, essayez notre logiciel de caisse « LOCAA » gratuitement pendant 30 jours et sans engagement. ", -1))
const _hoisted_11 = { class: "main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Galleria = _resolveComponent("Galleria")!
  const _component_HomeFeature = _resolveComponent("HomeFeature")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_HomeSubscription = _resolveComponent("HomeSubscription")!
  const _component_HomeFooter = _resolveComponent("HomeFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Galleria, {
      "show-thumbnails": false,
      value: _ctx.items,
      numVisible: 1
    }, {
      item: _withCtx((slotProps) => [
        _createElementVNode("div", {
          style: _normalizeStyle('background-image: url(' + './' + slotProps.item + ');'),
          class: "slider"
        }, [
          _createVNode(_component_Toolbar, { class: "bg-color" }, {
            start: _withCtx(() => [
              _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.$t("home.feature")), 1),
              _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.$t("home.subscription")), 1),
              _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.$t("home.contact")), 1)
            ]),
            end: _withCtx(() => [
              _createVNode(_component_Button, {
                label: _ctx.$t('login'),
                icon: "pi pi-search",
                class: "p-mr-2 p-button-warning",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/account/')))
              }, null, 8, ["label"]),
              _createVNode(_component_Button, {
                label: _ctx.$t(`signUp.signUp`),
                icon: "pi pi-user-plus",
                class: "p-button-info p-button-outlined",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/account/sign-up')))
              }, null, 8, ["label"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t("home.discover")), 1),
              _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.$t("home.discover1")), 1)
            ]),
            _hoisted_10
          ])
        ], 4)
      ]),
      _: 1
    }, 8, ["value"]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_HomeFeature, { id: "feature" }),
      _createVNode(_component_Divider),
      _createVNode(_component_HomeSubscription, { id: "subscription" })
    ]),
    _createVNode(_component_HomeFooter)
  ]))
}